module.exports = __webpack_public_path__ + "img/flash-indigo.6507b033.svg";